module.exports = __webpack_public_path__ + "static/media/ryen.60f73580.png";